/* eslint-disable jsx-a11y/anchor-is-valid */

import {FC, useEffect, useMemo, useState} from 'react'
import {KTableProvider, useKTable} from '../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../models/utility.model'
import {Column} from 'react-table'
import {CheckingModel} from '../../../models/ckecking.model'
import {KTable, KTableHeader, KTableLoading} from '../../../../../components/UI'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {FormProvider, useForm} from 'react-hook-form'
import {InputDate} from '../../../../../components/UI/Input'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {yupResolver} from '@hookform/resolvers/yup'
import {CheckInListFiltersModel} from '../../checkInList/model/checkInList.model'
import {checkinAppSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {getCheckingService2} from '../../../services/checking.service'
import {useAuth} from '../../../../../hooks/useAuth'

const TableBookingApp: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
    selectedOn,
  } = useKTable()
  const methods = useForm<CheckInListFiltersModel>({
    resolver: yupResolver(checkinAppSchema),
  })
  const {
    // control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    // watch,
    reset,
  } = methods
  const {currentTabItem} = useHoteleria()
  const {user} = useAuth()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const [formValue, setFormValue] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [statusType, setStatusType] = useState<SelectOption[]>([])

  const {getSites, getCamps, getMasterTable} = useCentralServices()

  ///

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSite(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    setCamp(data)
  }

  const getCompanyTypesFn = async () => {
    const data = await getMasterTable('TipoEmpresa', true)
    setCompanyType(data)
  }

  const getStatusTypesFn = async () => {
    const data = await getMasterTable('EstadoReservaCamaHuesped', true)
    setStatusType(data)
  }

  const handleFilterCamp = (e: any, name: string) => {
    let value = e.value
    getCampsFn(value)
    const {CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  ///

  const getChekings = async () => {
    try {
      if (formValue) {
        setLoading(true)
        const {data: response} = await getCheckingService2({
          pageNumber: pagination.currentPage,
          size: pagination.perPage,
          // UsuarioId: 'AWt6sEtLz9pVzvDcgZfaU7cq9AyjJAne',
          UsuarioId: user.id,
          ...formValue,
          ...searchValues,
        })
        if (!response.error) {
          setData(response.data)
          setPagination({
            ...pagination,
            totalResults: response.total,
          })
        }
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getChekings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<CheckingModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'SiteId'}
            selecteable
            data={site}
            onGetValueSelect={handleFilterCamp}
          />
        ),
        accessor: 'Site',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Módulo' name='CodigoModulo' searcheable />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Habitación' name='CodigoHabitacion' searcheable />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cama' name='CodigoCama' searcheable />
        ),
        accessor: 'CodigoCama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'CodigoReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tip. Empresa'
            name='TipoEmpresaId'
            selecteable
            data={companyType}
          />
        ),
        accessor: 'TipoEmpresa',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='EstadoReservaCamaId'
            selecteable
            data={statusType}
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Inicio Programada'
            name='FechaIni'
            dateable
          />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin Programada' name='FechaFin' dateable />
        ),
        accessor: 'FechaFin',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Checkin' name='FechaCheckInIni' dateable />
        ),
        accessor: 'FechaCheckIn',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Checkout'
            name='FechaCheckOutIni'
            dateable
          />
        ),
        accessor: 'FechaCheckOut',
      },
    ],
    [site, camp, companyType, statusType, selectedOn],
  )

  useEffect(() => {
    getSitesFn()
    // getCampsFn()
    getCompanyTypesFn()
    getStatusTypesFn()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        if (formValue) {
          getChekings()
        }
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        if (formValue) {
          getChekings()
        }
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setCamp([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaEstadiaIni', value)
    setError('FechaEstadiaIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaEstadiaFin', value)
    setError('FechaEstadiaFin', {})
  }

  const handleClear = () => {
    reset()
    setFormValue(null)
    setData([])
    setClearTable(true)
  }

  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const onSubmit = (dataForm: CheckInListFiltersModel) => {
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setFormValue(dataForm)
    setFormValueLoading(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <FormProvider {...methods}>
          <form className='m-2'>
            <div className='row'>
              <div className='col-sm-12 col-lg-3'>
                <label className='required'>Fecha Inicio de Estadia</label>
                <InputDate
                  name='FechaEstadiaIni'
                  register={register}
                  errors={errors}
                  onChange={handleChangeDateIni}
                />
              </div>
              <div className='col-sm-12 col-lg-3'>
                <label className='required'>Fecha Fin de Estadia:</label>
                <InputDate
                  name='FechaEstadiaFin'
                  register={register}
                  errors={errors}
                  onChange={handleChangeDateFin}
                />
              </div>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          </form>
          <ButtonWrapper className={'sdx-white-bg'}>
            <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
            <Button label='Limpiar' onClick={handleClear} />
          </ButtonWrapper>
        </FormProvider>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={data} columns={columns} clearFilters />
      </KTCard>
    </>
  )
}

const TableBookingAppWrapper = () => {
  return (
    <KTableProvider>
      <TableBookingApp />
    </KTableProvider>
  )
}

export {TableBookingAppWrapper}
